import { useQuery} from '@tanstack/react-query'
import { NexusService } from '../global-APIs/nexus-service'

export const usePromoPartners = () => {

  const { data: promoPartners } = useQuery({
    queryKey: ['/promopartners'],
    queryFn: async () => {
      const res = await NexusService.listPromoPartners()
      return {promoPartners: res.resultsList}
    },
    placeholderData: {
        promoPartners: [],
      },
    }
  )

  return {
    promoPartners,
  }
}

